// DEPRECATED COMPONENT, DO NOT USE. USE LogoLoader from APP-COMPONENTS INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { ICONS } from "./constants";

/**
 *
 * @visibleName UULogoLoader DEPRECATED
 */
var UULogoLoader = function UULogoLoader(props) {
  var id = props.id,
    description = props.description,
    height = props.height,
    width = props.width,
    style = props.style;
  var icon = ICONS.IconUULogoLoader;
  var iconImage = get(icon, 'markup', null);
  var viewBox = get(icon, 'viewBox', null);
  return /*#__PURE__*/React.createElement("div", {
    className: "ui-uu-logo-loader",
    id: id,
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    viewBox: viewBox
  }, iconImage), !isEmpty(description) && /*#__PURE__*/React.createElement("p", {
    className: "ui-uu-logo-loader__text text-center"
  }, description));
};
UULogoLoader.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** text to appear below UULogoLoader image */
  description: PropTypes.string,
  /** height of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
   */
  height: PropTypes.number,
  /** width of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
   */
  width: PropTypes.number,
  /** Override the inline-styles of the UULogoLoader || **Not Recommended** */
  style: PropTypes.object
};
UULogoLoader.defaultProps = {
  id: '',
  description: '',
  height: null,
  width: null,
  style: {}
};
export default UULogoLoader;